<template>

    <!-- <div v-for="dish in dishes" :key="dish.id">

        <div>{{ dish.name }}</div>

        <div>{{ dish.description }} </div>

        <div class="d-flex justify-content-between">
            <button class="btn btn-danger btn-sm" @click="removeDish(dish.id)">Remove</button>
            <div>
                <modal-slot buttonName="Edit Dish">
                    <template #default="{ closeModal }">
                        <UpdateDish :dish="dish" :closeModal="closeModal"></UpdateDish>
                    </template>
                </modal-slot>
            </div>
            
        </div>
    </div> -->

    <div class="card mb-3" v-for="dish in dishes" :key="dish.id">
        <div class="row g-0">
            <div class="col-md-4">
                <div>
                    <img :src=  "dish.image" class="img-fluid" alt="...">
                        <input type="file" :key="inputKey" @change="handleFileUpload($event, dish.id)" />
                </div>
                
            </div>
            <div class="col-md-8">
                <div class="card-body">
                    <h5 class="card-title">{{ dish.name }}</h5>
                    <p class="card-text">{{ dish.description }}</p>
                </div>
                <div class="d-flex justify-content-around">
                    <button class="btn btn-danger btn-sm" @click="removeDish(dish.id)">Remove</button>
                    <div>
                        <modal-slot buttonName="Edit dish">
                            <template #default="{ closeModal }">
                                <UpdateDish :dish="dish" :closeModal = "closeModal"></UpdateDish>
                            </template>
                            
                        </modal-slot>

                    </div>
                </div>
            </div>
        </div>
    </div>


</template>

<script setup>
import { useKitchenStore } from "@/stores/kitchen";
import { computed, ref } from "vue";
import { useRoute } from "vue-router";
import ModalSlot from '../utils/ModalSlot.vue';
import UpdateDish from './UpdateDish.vue'
import api from "@/services/api";

import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';

    const inputKey = ref(Date.now());

    const store = useKitchenStore();

    const route = useRoute();

    const dishes = computed(()=>{
        const kitchen = store.kitchens.find(k => {
            if(k.id == route.params.id){
                return k;
            }
        });

        return  kitchen.dishes;

    })

async function removeDish(id){
    try{
      await api.get('/user/admin/dish/'+id);
      store.removeDish(id);
    }catch(error){
        console.log('something went wrong');
    }
}



async function handleFileUpload(event, id){

    const formData = new FormData();
   formData.append('image', event.target.files[0]);

  try {
    const dish =  await api.post('user/admin/upload/dish/'+id, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    store.addDishToKitchen(dish.data);
    toast("Image uploaded!", {
        autoClose: 1000,
      });


      inputKey.value = Date.now();

  } catch (error) {
    inputKey.value = Date.now();
    alert('Image upload failed.');
  }

}

</script>

<style scoped>

    /* Container for the image and button */
.image-container {
  position: relative; /* Positioning needed for overlay */
  display: inline-block; /* Adjust as needed */
  width: 100px; /* Set your desired image size */
  height: 100px; /* Keep it square for a circular shape */
  overflow: hidden; /* Ensures rounded corners work */
  border-radius: 50%; /* Makes the container circular */
}

/* Rounded Image */
.rounded-image {
  width: 100%;
  height: 100%;
  object-fit: cover; /* Ensures the image fits nicely within the container */
  display: block; /* Removes any unwanted space below the image */
}

/* Button Overlay */
.overlay-button {
  position: absolute; /* Position relative to the container */
  bottom: 10%; /* Adjust the button's position */
  left: 50%; /* Center horizontally */
  transform: translateX(-50%); /* Center alignment */
  padding: 10px 20px; /* Adjust size */
  background-color: rgba(0, 0, 0, 0.7); /* Semi-transparent background */
  color: white; /* Button text color */
  border: none; /* Remove default border */
  border-radius: 5px; /* Rounded button corners */
  cursor: pointer; /* Pointer cursor on hover */
  font-size: 16px; /* Button text size */
  z-index: 2; /* Ensure it appears above the image */
}

/* Button Hover Effect */
.overlay-button:hover {
  background-color: rgba(0, 0, 0, 0.9);
}

    
</style>